import { APP_INITIALIZER, enableProdMode, ErrorHandler, inject } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter, Router } from '@angular/router';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import {
  HttpEvent,
  provideHttpClient,
  withFetch,
  withInterceptors,
} from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { ErrorInterceptor, LoadInterceptor } from "./app/util/interceptors";
import { Observable } from "rxjs";
import * as Sentry from "@sentry/angular";
import { GlobalErrorHandler } from "./app/util/interceptors/global-error-handler";
import { DatePipe } from "@angular/common";
import { provideNgxMask } from 'ngx-mask';


if (environment.production) {
  enableProdMode();
}

if (environment.isSentryEnabled) {
  Sentry.init({
    dsn: "https://36b60aedb643af0e8b6e76479a69c692@o4509112059494400.ingest.de.sentry.io/4510596101177424",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/models\.orcainc\.com\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

bootstrapApplication(AppComponent, {
  providers: [
    DatePipe,
    provideNgxMask(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        (req, next): Observable<HttpEvent<any>> => inject(LoadInterceptor).intercept(req, next),
        (req, next): Observable<HttpEvent<any>> => inject(ErrorInterceptor).intercept(req, next),
      ]),
    ),
    LoadInterceptor, // need to provide it also here, otherwise it will not be injected
    ErrorInterceptor,
    provideAnimations(),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => (): void => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
}).catch((err) => console.error(err));

